<template>
  <div class="user-layout">
    <ReactUserSettingsNavigation
      v-if="useReactUserSettingsNavigation && !mobile"
      style="width: auto; padding: 16px 0 16px 16px; background: var(--palette-paper-elevation0)"
    />
    <div
      v-else-if="!mobile"
      class="user-layout_left"
      style="overflow: hidden; position: relative"
    >
      <router-link
        v-for="(item, iIdx) in links"
        :key="`${item.pathName}_${iIdx}`"
        :to="{ name: item.pathName }"
        :class="{ 'no-events': item.disabled }"
      >
        <NavCard
          :class="{ opacity_7: item.disabled }"
          :item="{
            ...item,
            ...(item.pathName === 'UserCredits'
              ? {
                  sub: $t('links.UserCredits_sub', {
                    credits_balance: animatedCreditBalance.toLocaleString(),
                  }),
                }
              : {}),
          }"
          class="navcard_menu navcard_menu-trigger navcard_router-link"
          style="
            --height: 3rem;
            --clr-text: var(--clr-grey-2);
            --clr-tag-back: var(--clr-black-4);
            --clr-sub-active: var(--clr-primary);
            --clr-sub-hover: var(--clr-primary);
          "
          :hasSub="item.pathName === 'UserCredits'"
        >
          <template
            v-if="item.pathName === 'UserCredits'"
            #icon
          >
            <Chip class="navcard_svg" />
          </template>
        </NavCard>
      </router-link>
    </div>

    <div class="user-layout_center">
      <transition
        name="slide"
        mode="out-in"
      >
        <div
          v-if="isRouteWithLayout"
          :key="$route.name"
          class="bb-grey"
          :class="
            mobile
              ? 'pa-4'
              : useReactUserSettingsNavigation
                ? 'pt-8 pb-4 ml-8 mr-12'
                : 'pt-8 pb-4 mx-12'
          "
        >
          <h3>
            {{ $t(`links.${$route.name}`) }}
          </h3>
          <div
            v-if="$route.name === 'UserSubscription' || $route.name === 'UserAccount'"
            class="text-medium clr-grey"
          >
            <span>{{ $t('messages.subscription_subtitle_help_links.start') }}</span>
            <OpenChatLink :text="$t('common.here')" />
            <span
              v-html="
                $t('messages.subscription_subtitle_help_links.end', {
                  mailto: 'mailto:hello@gtowizard.com?subject=Subscription',
                  email: 'hello@gtowizard.com',
                })
              "
            />
          </div>
        </div>
      </transition>

      <router-view v-slot="{ Component }">
        <transition
          name="slide"
          mode="out-in"
        >
          <component
            :is="Component"
            :key="$route.name"
            :ref="$route.name"
            :class="
              mobile ? 'ma-4' : useReactUserSettingsNavigation ? 'mt-4 ml-8 mr-12' : 'mt-4 mx-12'
            "
          />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
import links_mix from '@/mixins/links_mix'
import OpenChatLink from '@/components/Payments/OpenChatLink.vue'
import Chip from '@/assets/icons/chip.svg'
import ReactUserSettingsNavigation from '@/components/AppBar/ReactUserSettingsNavigation.vue'
import { useAnimatedNumber } from '@/composables/useAnimatedNumber'
import { ref, computed } from 'vue'

export default {
  name: 'UserSettings',
  components: { OpenChatLink, ReactUserSettingsNavigation, Chip },
  mixins: [links_mix],
  data() {
    return {
      animatedCreditBalance: ref(0),
    }
  },
  created() {
    this.$store.dispatch('account_settings_user_only')

    const creditBalance = computed(() => this.$store.getters.user_info.credit_balance)
    const { animatedValue } = useAnimatedNumber(creditBalance, 1000)
    this.animatedCreditBalance = animatedValue
  },
  computed: {
    user_info() {
      const { user_info } = this.$store.getters
      return user_info
    },
    isRouteWithLayout() {
      return this.$route.name !== 'UserSubscriptionsOverview' && this.$route.name !== 'UserCredits'
    },
    useReactUserSettingsNavigation() {
      return this.$store.getters.user_has_flag('REACT_USER_SETTINGS_NAVIGATION')
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    links() {
      return this.links_settings.filter(i =>
        this.$store.getters.sol_elite.can_use ? true : i.pathName !== 'UserCredits',
      )
    },
  },
}
</script>
<style lang="scss">
.user-layout {
  flex: 1;
  display: flex;
  &_center {
    height: var(--vh-3);
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: var(--palette-background-default);
  }
  &_left {
    width: 14rem;
    padding: 0.5rem 0;
    background: var(--clr-black-1);
  }
}

.user-themes {
  position: relative;
  flex: 1;
  &_row {
    display: flex;
    flex-wrap: wrap;
  }
  &_block {
    display: flex;
    flex-direction: column;
    &_right {
      border-left: solid var(--clr-black-3) 1px;
      margin-left: 1rem;
      padding-left: 2rem;
    }
  }
}

.theme-preview {
  &_graph {
    max-width: 22rem;
  }
}
</style>
